export default class Cart {
    constructor(axios, payload) {
        this.payload = payload
        this.axios = axios
    }

    addToCart() {
        
        return this.axios.post('index.php?m=proxycheap&json=1&c=AddToWHMCSCart', this.payload)
    }
}
